
        import _47opt_47buildhome_47repo_47node_modules_47_64nuxt_47ui_47dist_47runtime_47vue_47plugins_47head_46js from "/opt/buildhome/repo/node_modules/@nuxt/ui/dist/runtime/vue/plugins/head.js"
import _47opt_47buildhome_47repo_47node_modules_47_64nuxt_47ui_47dist_47runtime_47plugins_47colors_46js from "/opt/buildhome/repo/node_modules/@nuxt/ui/dist/runtime/plugins/colors.js"
import _47opt_47buildhome_47repo_47node_modules_47_64nuxt_47ui_47dist_47runtime_47vue_47plugins_47color_45mode_46js from "/opt/buildhome/repo/node_modules/@nuxt/ui/dist/runtime/vue/plugins/color-mode.js"
export default {
  install (app) {
    app.use(_47opt_47buildhome_47repo_47node_modules_47_64nuxt_47ui_47dist_47runtime_47vue_47plugins_47head_46js)
    app.use(_47opt_47buildhome_47repo_47node_modules_47_64nuxt_47ui_47dist_47runtime_47plugins_47colors_46js)
    app.use(_47opt_47buildhome_47repo_47node_modules_47_64nuxt_47ui_47dist_47runtime_47vue_47plugins_47color_45mode_46js)
  }
}
        